import { useReducer } from 'react';
import { OffsiteCampaignEditorReducer } from './OffsiteCampaignEditorReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  OffsiteCampaignEditorDispatchContext,
  OffsiteCampaignEditorStateContext,
} from './UseOffsiteCampaignEditorContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface IOffsiteCampaignEditorProviderProps {
  children: any;
  value?: IValue;
}

export function OffsiteCampaignEditorProvider({
  children,
  value = { initialState: defaultContextValues, reducer: OffsiteCampaignEditorReducer },
}: IOffsiteCampaignEditorProviderProps) {
  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <OffsiteCampaignEditorStateContext.Provider value={state}>
      <OffsiteCampaignEditorDispatchContext.Provider value={dispatch}>
        {children}
      </OffsiteCampaignEditorDispatchContext.Provider>
    </OffsiteCampaignEditorStateContext.Provider>
  );
}
